import Konva from 'konva';
import HaspObject from './HaspObject';
import { processIconText } from '../utils/iconFonts';

// val	int8	0	The number of the active tab, starting at 0
// text	string	""	The name of the active tab
// btn_pos	0..4	1	Position of the tab buttons:
//         0 = none
//         1 = top
//         2 = bottom
//         3 = left
//         4 = right
// count	uint16	0	Read-only The number of tabs of the tabview

export default class HaspTabview extends HaspObject {
  tabs = [];
  barHeight = 50;
  tabButtPadding = 20;

  btn_pos_options = [
    { value: 0, description: "none" }, //useless
    { value: 1, description: "top" },
    { value: 2, description: "bottom" },
    // { value: 3, description: "left" }, //crash device
    // { value: 4, description: "right" },//crash device
  ]

  constructor(config) {
    super(config);

    this.on('transform', (e) => {
      // this.buttonBarGroup.width(this.width())
      // this.barBg.width(this.width());
      this.drawTabs();
    });

    this.on('transformend', (e) => {
      this.drawTabs();
    });

    this.on('text_font', (e) => {
      this.drawTabs();
    });

    this.on('text_font_family', () => {
      this.drawTabs();
    });

    this.onStyle('indicator', 'bg_color', () => {
      if (this.selectLine)
        this.selectLine.stroke(this.style('indicator').bg_color);
    })

    this.onStyle('items', 'bg_color', () => {
      if (this.barBg)
        this.barBg.fill(this.style('items').bg_color);
    })

    this.onStyle('items', 'border_color', () => {
      if (this.barBg)
        this.barBg.stroke(this.style('items').border_color);
    })

    this.onStyle('items', 'border_width', () => {
      if (this.barBg)
        this.barBg.strokeWidth(this.style('items').border_width);
    })

    this.onStyle('items', 'radius', () => {
      if (this.barBg)
        this.barBg.cornerRadius(this.style('items').radius);
    })

    this.on('btn-pos', (e) => {
      this.drawTabs();
    })


    // this.add(this.buttonBarGroup)
    this.drawTabs();
    this.draggable(true);
  }

  setNewSize(size) {
    super.setNewSize(size);
    this.drawTabs();
  }

  drawTabs() {
    //first create a new group
    if (this.buttonBarGroup) this.buttonBarGroup.destroy();
    let barPosition = { x: 0, y: 0 };
    let barSize = { width: 0, height: 0 };
    let butSize ={ width:this.width() / this.tabs.length, height: this.barHeight };
    switch (this.btn_pos) {
      case 0: // none
       return;  
        break;
      case 1: // top  
        barPosition = { x: 0, y: 0 };
        barSize = { width: this.width(), height: this.barHeight };
        break;
      case 2: // bottom
        barPosition = { x: 0, y: this.height() - this.barHeight };
        barSize = { width: this.width(), height: this.barHeight };
        break;
      case 3: // left
        barPosition = { x: 0, y: 0 };
        barSize = { width: this.barHeight, height: this.height() };
        butSize = {width: barSize.width, height: barSize.height / this.tabs.length}
        break;
      case 4: // right    
        barPosition = { x: this.width() - this.barHeight, y: 0 };
        barSize = { width: this.barHeight, height: this.height() };
        butSize = {width: barSize.width, height: barSize.height / this.tabs.length}
        break;
      default:  // none
        barPosition = { x: 0, y: 0 };     
        barSize = { width: this.width(), height: this.barHeight };
        break;
    }
    this.buttonBarGroup = new Konva.Group({
      x: barPosition.x,
      y: barPosition.y,
      width: barSize.width,
      height: barSize.height,
      listening: true,
    })
    const items = this.style('items');
    this.barBg = new Konva.Rect({
      x: 0,
      y: 0,
      width: barSize.width,
      height: this.buttonBarGroup.height(),
      cornerRadius: items.radius,
      fill: items.bg_color,
      stroke: items.border_color,
      strokeWidth: items.border_width,
      obj: 'emptytab',
      listening: false,
    })
    this.buttonBarGroup.add(this.barBg);
    this.add(this.buttonBarGroup);

    //create all tabBar buttons
    const tabButWidth = this.width() / this.tabs.length;
    this.tabs.map((tab, pos) => {
      const txtObj = new Konva.Text({
        x: pos * tabButWidth,
        y: 0,
        height: 'auto',
        width: tabButWidth,
        verticalAlign: 'middle',
        text: processIconText(tab.text),
        fontSize: this.text_font,
        fontFamily: this.text_font_family || 'Roboto Condensed',
        listening: true,
        obj: 'tab_button',
        tab: tab,
        fill: 'white',//this.text_color,
        align: 'center',
      })
      //the textheight has padding
      txtObj.height(txtObj.height() + 2 * (this.tabButtPadding))
      //set all te correct heights
      this.barBg.height(txtObj.height()); // match bg to buttrect
      this.buttonBarGroup.height(this.barBg.height());
      tab.setSize(this.width(), this.height() - this.barBg.height())
      //position the bar based on btn_pos
      if (this.btn_pos === 2) { // bottom position, only top and bottom work. left and richt crash the device and none seems useless
        this.buttonBarGroup.y(this.height() - this.barBg.height())
        tab.y(0);
      } else { // top
        this.buttonBarGroup.y(0);
        tab.y(this.barBg.height());
      }

      // this.buttonBarGroup.add(tabButt);
      this.buttonBarGroup.add(txtObj);

      //line is placed depending on btn_pos
      var txt_y = txtObj.height() - 2
      if (this.btn_pos === 2) txt_y = 2;

      if (tab.selected) {
        this.activeTab = tab;
        this.selectLine = new Konva.Line({
          x: pos * tabButWidth,
          y: txt_y,
          points: [0, 0, tabButWidth, 0],
          stroke: this.style('indicator').bg_color,
          strokeWidth: 4,
        });
        this.buttonBarGroup.add(this.selectLine);
      }      // tab.setSize(this.width(), (this.height() - this.barBg.height()));
      // tab.setActive(true)
      if (this.activeTab !== undefined) {
        this.activeTab.moveToTop();
      }
    })

    this.buttonBarGroup.moveToTop();
    this.idTextObj.moveToTop();
  }

  // updateId(id) {
  //   this.haspid = id;
  //   this.textObj.setAttr('text', id);
  // }

  addItem(item) {
    if (item.isType('tab')) {
      item.x(0);
      item.y(this.barHeight);
      item.setSize(this.width(), (this.height() - this.barBg.height()));
      item.tabview = this;
      this.add(item);
      this.tabs.push(item);
      this.setSelectedTab(item);
      if (item.text === 'Tab') {
        item.text = 'Tab' + this.tabs.length;
      }
      this.drawTabs();
    } else {
      if (this.activeTab !== undefined) {
        this.activeTab.addItem(item);
      }
    }
    return item;
  }

  setSelectedTab(tab) {
    if (this.activeTab !== undefined) {
      this.activeTab.setSelected(false);
      this.activeTab.visible(false);
    }
    this.activeTab = tab;
    this.activeTab.setSelected(true);
    this.activeTab.visible(true);
  }

  /**
   * delete tab if active tab exists
   * @returns did delete
   */
  deleteActiveTab() {
    if (this.activeTab !== undefined) {
      this.tabs = this.tabs.filter(tab => tab.uuid != this.activeTab.uuid)
      this.activeTab.destroy();
      this.activeTab = undefined;
      this.drawTabs();
      return true;
    }
    return false;
  }

  callback(tab) {
    this.drawTabs();
  }

  objectExport(page, objectData) {
    //unset a lot of export values
    // objectData.border_color = undefined;
    // objectData.border_width = undefined;
    // objectData.bg_color = undefined;
    // objectData.radius = undefined;
    this.tabs.map((tab, index) => {
      tab.moveToTop();
    });
  }
}
